import { IDevice, IScreenCanvasSizes } from "@kuika/kuika-cl-model";
import { IScreenDesignContextState } from "../../contexts/screen-design-context/screen-design-context";
import type { ScreenDesignInstance } from "./designer-context";
import { getValues } from "./designer-context";

/** Element type of IScreenCanvasSizes.screens (not exported directly from the model package) */
type ScreenCanvasSizeEntry = NonNullable<IScreenCanvasSizes["screens"]>[number];

function updateScreenCanvasWidth(sd: IScreenDesignContextState, width: number, device?: IDevice): void {
  if (!width || !sd?.project || !sd?.updateProject || !sd?.sdId) return;

  // A report is sized by its paper, never by a viewport. The device menu is not even mounted in
  // the Report Designer, but the tool switches to UI Design before the screen does, so on the way
  // out the report is still the loaded screen — and it used to take the phone width written here,
  // which then fought the paper size for the rest of the session.
  if (sd.isLoadedScreenReport?.() === true) return;

  const { project } = sd;
  const { screenCanvasSizes = { width: undefined, deviceType: "Desktop" as const } } = project;
  const screen: ScreenCanvasSizeEntry | undefined = screenCanvasSizes?.screens?.find(
    (item: ScreenCanvasSizeEntry) => item?.id === sd.sdId
  );

  if (screenCanvasSizes.width === width && (!screen || screen.width === width)) {
    return;
  }

  const screens: ScreenCanvasSizeEntry[] = screenCanvasSizes?.screens || [];
  if (screen) {
    screen.width = width;
    screen.device = device;
    screen.deviceType = undefined;
  } else {
    screens.push({
      id: sd.sdId,
      width,
      deviceType: undefined,
      device
    });
  }

  sd.updateProject({
    ...project,
    screenCanvasSizes: {
      ...screenCanvasSizes,
      screens
    }
  });
}

export function selectDesignerViewportDevice(sdInstance: ScreenDesignInstance, device: IDevice): void {
  const sd: IScreenDesignContextState = getValues(sdInstance);
  if (!sd || !device || !sd.setSpecificDevice) return;

  sd.setSpecificDevice(device, true);

  const viewport = device.viewport;
  if (!viewport || viewport.toLowerCase() === "custom") return;

  const width = parseInt(viewport.substring(0, viewport.indexOf("x")), 10);
  if (!isNaN(width)) {
    updateScreenCanvasWidth(sd, width, device);
  }
}
